export enum MemberType {
  SELLER = 'seller',
  PARTNER = 'partner',
  FREE = 'free',
  BUYER = 'buyer',
}
